module.exports = __webpack_public_path__ + "static/kbusiness1-0f6c0fc80ddc51ac590970bf34010a3c.png";